import React, { useContext } from 'react'
import { Container, Title, Emoji } from '@provi/provi-components'
import { TemplateContext } from '../../../components/template/context'
import { useISAContext } from '../../../components/template/ISA/context'
import { TemplateFormIsa } from '../../../components/template-isa'
import { FormFomik } from './form'

export const ReasonsTrust = () => {
  const { creditPath } = useContext(TemplateContext)
  const { goToNextScreen } = useISAContext()
  return (
    <TemplateFormIsa>
      <Container>
        <Title
          text={
            <>
              Nos dê três boas razões para confiarmos em você e nos diga o porquê <Emoji symbol="😊" label="wink" />
            </>
          }
        />
        <FormFomik data={creditPath && creditPath.ReadReasonsToTrustYouAndWhy} goToNextScreen={goToNextScreen} />
      </Container>
    </TemplateFormIsa>
  )
}
